import React from 'react'
import PropTypes from 'prop-types'
import ReactPaginate from 'react-paginate'
import { ratingClassification } from '../../common/constants/classifications'
import Review from '../../common/components/review/review'
import ScrollableAnchor, { configureAnchors } from 'react-scrollable-anchor'
import { OFFSET_TOP } from './constant'
import './Reviews.scss'
import { withNamespaces } from "react-i18next"
import { compose } from 'redux'

export class Reviews extends React.Component {
  constructor(props) {
    super(props)
    this.state = { width: window.innerWidth }
    this.updateWidth = this.updateWidth.bind(this)
    configureAnchors({ offset: OFFSET_TOP.PC })
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount() {
    window.addEventListener('resize', this.updateWidth)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWidth)
  }

  updateWidth() {
    this.setState({ width: window.innerWidth })
  }

  count(value) {
    const { buckets } = this.props.stats.overall_histogram
    const bucket = buckets.find(bucket => bucket.key == value)
    return (bucket && bucket.doc_count) || 0
  }

  share(value) {
    const total = this.props.stats.overall_stats.count
    return Math.round((this.count(value) / total) * 100)
  }

  get average() {
    return this.props.stats.overall_stats.avg.toFixed(1)
  }

  get classification() {
    return ratingClassification(this.average)
  }

  get classificationClass() {
    return this.classification.toLowerCase().replace(/ /g, '-').replace(/[^\w-]/, '')
  }

  render() {
    const { t } = this.props
    return (
      <section id="review">
        <ScrollableAnchor id={'review'}><div></div></ScrollableAnchor>
        <h2><span className="notranslate">{this.props.reviewCount}</span>{ t('reviews.title') }</h2>
        <div styleName="aggregation" itemProp="aggregateRating" itemScope itemType="" itemType="http://schema.org/AggregateRating">
          <div styleName="share">
            <table>
              <tbody>
                {[5, 4, 3, 2, 1].map(i => {
                  const share = this.share(i)
                  return <tr styleName="row" key={i}>
                    <th styleName="label">{ t(`rating.${i}`) }</th>
                    <td styleName="indicator">
                      <div styleName="bar"><span style={{ width: `${share}%` }}></span></div>
                    </td>
                    <td styleName="percentage"><span>{share}</span>%</td>
                  </tr>
                })}
              </tbody>
            </table>
          </div>
          <div styleName={`average average-${this.classificationClass || 'default'}`}>
            <div>
              <meta itemProp="bestRating" content="5" />
              <meta itemProp="worstRating" content="1" />
              <h4>{ t('reviews.average_rating') }</h4>
              <div styleName="rating" itemProp="ratingValue">{this.average}</div>
              <div>{this.classification}</div>
            </div>
          </div>
        </div>
        <div className="reviews">
          {this.props.reviews && this.props.reviews.results && this.props.reviews.results.map((review, index) => {
            return <Review review={review} guestUser={review.guest_user} key={index} translationEnabled={true} />
          }) }
          { this.props.totalPages > 1 &&
          <div className="pagination-wrapper">
            <nav>
              <ReactPaginate
                previousLabel={<i className="icon icon-prev" />}
                nextLabel={<i className="icon icon-next" />}
                pageCount={this.props.totalPages}
                pageRangeDisplayed={this.state.width > 400 ? 4 : 2}
                marginPagesDisplayed={1}
                hrefBuilder={() => location.href}
                disableInitialCallback={true}
                onPageChange={(page) => this.props.onPageChange(page) }
                containerClassName="pagination"
                pageLinkClassName="page"
              />
            </nav>
          </div>
          }
        </div>
      </section>
    )
  }

  static propTypes = {
    lang: PropTypes.string,
    stats: PropTypes.object,
    reviews: PropTypes.object,
    totalPages: PropTypes.number,
    onPageChange: PropTypes.func
  }

  static defaultProps = {
    lang: '',
    stats: {},
    reviews: {},
    totalPages: 1,
    onPageChange: () => {}
  }
}

export default compose( withNamespaces('listings') )(Reviews)
